const base = "admins.invite.errors.";

export type InviteErrorFallback = "sendFailed" | "loadFailed";

export function getInviteErrorKey(err: unknown, fallback: InviteErrorFallback): string {
  const body = (err as { error?: unknown })?.error;
  if (body && typeof body === "object") {
    const message =
      (body as { message?: string; errorMessage?: string }).message ?? (body as { message?: string; errorMessage?: string }).errorMessage;
    if (typeof message === "string" && message.toLowerCase().includes("already a member")) {
      return base + "userAlreadyMember";
    }
  }
  return base + fallback;
}
